export default {
    baseUrl: {
        development: 'http://localhost:1889/api/v1',
        production: 'postweb/api/v1'
    },
    secret: {
        development: "745cba2e2defce8bd227d5df7ec4ca06",
        production: "745cba2e2defce8bd227d5df7ec4ca06"
    }
}